import { makeHttpRequest } from "@/shared";

import { mapEventsFromServer } from "./mappers/mapEventsFromServer";

export const getAllEvents = async () => {
    const response = (
        await makeHttpRequest({
            url: "/events/my",
            method: "GET",
        })
    ).data;

    return mapEventsFromServer(response.data);
};
